module.exports = __webpack_public_path__ + "img/card-brand-american-express.09c69c65.png";